module.exports = __webpack_public_path__ + "img/1.6cbab7a4.jpg";